module.exports = __webpack_public_path__ + "static/media/18ECA37.62f9e1c7.jpg";